import React from "react";
import { motion } from "framer-motion";

// Browser-style chrome bar with three dots and a fake url pill.
const BrowserChrome = ({ label = "shakti.design" }) => (
  <div className="flex items-center gap-2 px-4 h-9 bg-[#FFFFFF] border-b border-[#E4E6EC]/80">
    <span className="w-2.5 h-2.5 rounded-full bg-[#E7B3A3]" />
    <span className="w-2.5 h-2.5 rounded-full bg-[#E5D6A8]" />
    <span className="w-2.5 h-2.5 rounded-full bg-[#B7C7A6]" />
    <div className="flex-1 mx-3 h-5 rounded-full bg-white/70 border border-[#E4E6EC]/70 flex items-center justify-center">
      <span className="text-[10px] tracking-[0.14em] uppercase text-[#6E7583]">
        {label}
      </span>
    </div>
  </div>
);

// Desktop / browser mockup — rectangular, rounded-corner frame used across all case-study cards.
const DesktopMockup = ({ src, alt, label }) => (
  <div className="relative w-full rounded-[18px] overflow-hidden border border-[#0E1A2B]/10 bg-white shadow-[0_30px_60px_-30px_rgba(42,40,37,0.35),0_10px_30px_-15px_rgba(42,40,37,0.15)]">
    <BrowserChrome label={label} />
    <div className="relative w-full aspect-[16/10] bg-[#FFFFFF] overflow-hidden">
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="w-full h-full object-cover object-top"
      />
    </div>
  </div>
);

export const ProjectThumbnail = ({ project }) => {
  const t = project.thumbnail || { kind: "desktop", src: project.image };

  const chromeLabel =
    project.id === "uniacco-pdp"
      ? "uniacco.com / property"
      : project.id === "uniacco-copilot"
      ? "donna.uniacco.com"
      : project.id === "unicreds-crm"
      ? "crm.unicreds.com"
      : "shakti.design";

  return (
    <motion.div
      className="group relative overflow-hidden rounded-[28px] border border-[#E4E6EC]"
      style={{ background: project.color }}
      whileHover={{ scale: 1.012 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`project-thumbnail-${project.id}`}
    >
      <div className="relative w-full flex items-center justify-center p-6 md:p-9">
        <DesktopMockup src={t.src} alt={project.title} label={chromeLabel} />
      </div>
    </motion.div>
  );
};

export default ProjectThumbnail;
